module.exports = __webpack_public_path__ + "static/media/password-icon.bbc3ae67.svg";